import React from "react";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaLinkedin,
  FaFacebook,
  FaTwitter,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-[#111827] to-[#191c20] text-white py-12 mt-12 shadow-[0px_-40px_50px_0px_rgba(0,0,0,0.3)]">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-12">
          {/* Company Info with Logo */}
          <div className="space-y-6">
            <div className="flex items-center space-x-4">
              <img
                src="/logo.png"
                alt="Petriek Structures Logo"
                className="w-40 h-auto"
              />
            </div>
            <p className="text-lg text-gray-400">
              At Petriek Structures, we build with precision, integrity, and
              innovation. With years of expertise in construction, we deliver
              durable and sustainable infrastructure solutions that shape the
              future.
            </p>
          </div>

          {/* Services */}
          <div className="space-y-6">
            <h3 className="text-2xl font-semibold text-white">Our Services</h3>
            <ul className="space-y-3 text-lg text-gray-400">
              {[
                "Residential Construction",
                "Commercial Buildings",
                "Road & Bridge Construction",
                "Renovation & Remodeling",
              ].map((service, index) => (
                <li
                  key={index}
                  className="hover:text-white font-medium transition-all duration-300"
                >
                  {service}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-6">
            <h3 className="text-2xl font-semibold text-white">Contact Us</h3>
            <ul className="space-y-3 text-lg text-gray-400">
              {[
                { icon: <FaPhoneAlt size={20} />, text: "(702) 972-2139" },
                {
                  icon: <FaEnvelope size={20} />,
                  text: "info@petriekstructures.com",
                },
              ].map((contact, index) => (
                <li key={index} className="flex items-center">
                  <span className="mr-3 text-white">{contact.icon}</span>
                  <span>{contact.text}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Social Media */}
          <div className="space-y-6">
            <h3 className="text-2xl font-semibold text-white">Follow Us</h3>
            <div className="flex space-x-6 text-gray-400">
              {[
                {
                  icon: <FaLinkedin size={28} />,
                  link: "https://www.linkedin.com",
                },
                {
                  icon: <FaFacebook size={28} />,
                  link: "https://www.facebook.com",
                },
                {
                  icon: <FaTwitter size={28} />,
                  link: "https://www.twitter.com",
                },
              ].map((social, index) => (
                <a
                  key={index}
                  href={social.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-all duration-300"
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="border-t border-gray-700 mt-12 pt-6 text-center text-lg text-gray-500">
          <p>
            &copy; {new Date().getFullYear()} Petriek Structures. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
